/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { withValue } from 'fierry/react';


export default withValue(({ application }) =>
{
  return application.getGalaxy();
});
